import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Rating,
  Chip,
} from "@mui/material";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Kevin Shingala",
      business: "E-Commerce Business Owner",
      rating: 5,
      text: "Excellent service for GST registration and filing. The team is professional and responsive. Highly recommended for accounting and taxation services in Rajkot!",
    },
    {
      name: "Dax Patel",
      business: "Spices Trader",
      rating: 5,
      text: "SHREE CONSULTANCY helped me with business registration and accounting. Very satisfied with their expertise and timely support.",
    },
    {
      name: "Kirit Vyas",
      business: "Caterer",
      rating: 5,
      text: "Best Taxation services in Rajkot! They handled my income tax filing and provided excellent tax planning advice.",
    },
  ];

  return (
    <Box component="section" id="testimonials" sx={{ py: { xs: 10, md: 12 } }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="Testimonials"
              sx={{
                mb: 2,
                bgcolor: "rgba(30, 91, 92, 0.1)",
                color: "rgba(30, 91, 92, 1)",
                fontWeight: 500,
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: "bold",
                mb: 2,
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              What Our Clients Say
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "text.secondary", maxWidth: "32rem", mx: "auto" }}
            >
              Hear from businesses in Rajkot who trust SHREE CONSULTANCY for
              their financial needs.
            </Typography>
          </Box>
        </motion.div>

        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{ height: "100%" }}
              >
                {/* <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Rating
                      value={testimonial.rating}
                      readOnly
                      sx={{ mb: 2, color: 'rgba(30, 91, 92, 1)' }}
                    />
                    <Typography
                      variant="body1"
                      sx={{ mb: 3, fontStyle: 'italic', lineHeight: 1.6 }}
                    >
                      "{testimonial.text}"
                    </Typography>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {testimonial.name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {testimonial.business}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card> */}
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      p: 3,
                    }}
                  >
                    <Rating
                      value={testimonial.rating}
                      readOnly
                      sx={{ mb: 2, color: "rgba(30, 91, 92, 1)" }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        fontStyle: "italic",
                        lineHeight: 1.6,
                        flexGrow: 1,
                      }}
                    >
                      "{testimonial.text}"
                    </Typography>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {testimonial.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        {testimonial.business}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
